import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-card-item-holder',
  imports: [],
  templateUrl: './card-item-holder.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './card-item-holder.component.css'
})
export class CardItemHolderComponent {

}
